var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.281 3.778s-.223-1.475-.87-2.118C20.59.818 19.661.807 19.25.75 16.218.54 11.67.54 11.67.54h-.024S7.112.54 4.08.75c-.434.057-1.35.068-2.173.91-.647.643-.87 2.118-.87 2.118S.815 5.508.815 7.214v1.63c0 1.73.224 3.437.224 3.437s.222 1.474.869 2.128c.822.854 1.904.821 2.397.91 1.727.166 7.367.221 7.367.221s4.547-.022 7.579-.222c.41-.055 1.34-.055 2.161-.909.647-.654.87-2.128.87-2.128s.211-1.708.211-3.437v-1.63c0-1.707-.211-3.436-.211-3.436zm-7.003 4.035l-5.863 2.982V4.81l2.655 1.363 3.208 1.641z","fill":"currentColor","fillRule":"evenodd"}));
}

Youtube.defaultProps = {"viewBox":"0 0 23 16","width":"23","height":"16"};

module.exports = Youtube;

Youtube.default = Youtube;
